import { render, staticRenderFns } from "./AcceptPolicy.vue?vue&type=template&id=1dec7336&scoped=true&"
import script from "./AcceptPolicy.vue?vue&type=script&lang=js&"
export * from "./AcceptPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AcceptPolicy.vue?vue&type=style&index=0&id=1dec7336&scoped=true&lang=css&"
import style1 from "./AcceptPolicy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec7336",
  null
  
)

export default component.exports